import React, { Component } from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import gtag, { install } from 'ga-gtag';

// ユーザー特定のための乱数生成
const l = 16;
const c = "abcdefghijklmnopqrstuvwxyz0123456789";
const cl = c.length;
let r = "";
for(let i=0; i<l; i++) {
  r += c[Math.floor(Math.random()*cl)];
}
const uuid = r

export default class Web extends Component {

  componentDidMount () {
    if (this.props.match.params.section) {
      window.scrollTo(0, 100);
    }
    if ("30min.page" === document.domain) {
      ReactGA.initialize('UA-184751599-1', {gaOptions: {userId: uuid}});
      ReactGA.pageview(window.location.pathname + window.location.search);

      install('AW-404081375');
      gtag('config', 'AW-404081375');
      
      ReactPixel.init('750234562329469');
      ReactPixel.pageView();
    }
  }

  send() {
    //window.location.href = "http://30min-7085787.hs-sites.com/%E5%AE%9A%E6%9C%9F%E5%A5%91%E7%B4%84%E7%94%B3%E8%BE%BC-0";
    this.props.history.push({
      pathname: "/form",
      state: { uuid: uuid, campaign: window.location.pathname }
    });
  }

  render () {
    return (
    <div className="sp home">
      <div className="content-wrapper">
        <div className="trial">

          <div className="kv">
            <img src="/images/lp/trial/kv.png" alt="日々の家事。私たちと、ときどき、交代しませんか。" />
          </div>

          <div className="statement">
            <p>家事代行と聞くと、</p>
            <p>少し抵抗のある方、</p>
            <p>多いのではないでしょうか。</p>
            <p>私たちは、家事代行を、</p>
            <p>もっと気軽にしたいという想いから、</p>
            <p>新しいサービスをめざしています。</p>
            <p>｢ときどき家事を交代する｣という感覚で、</p>
            <p>気軽に体験してみませんか？</p>
          </div>

          <div className="cv-button">
            <button onClick={this.send.bind(this)}>お申し込みはこちら</button>
          </div>

          <div className="content bottom-space">
            <img src="/images/lp/trial/daycare_price.png" alt="お試しキャンペーン特典　1回あたり2750円×2週　最大3300円お得！" />
          </div>

          <div className="content">
            <p className="content-title">お客様の声</p>
            <div className="user-voice">
              <img src="/images/lp/trial/user_sa.png" alt="" />
              <p className="profile">港区在住・会社員・Sさん</p>
              <p className="comment">常に、お掃除が出来ていないという後ろめたい気持ちを持って生活していましたが、気持ちの負担が軽減され、ゆとりが生まれました。夜子供が寝た後の家事が無くなりゆっくりする時間が増えたり、家事に関する夫婦間の喧嘩が減ったのが嬉しいですね。</p>
            </div>
            <div className="user-voice">
              <img src="/images/lp/trial/user_ko.png" alt="" />
              <p className="profile">新宿区在住・自営業・Kさん</p>
              <p className="comment">これまでは汚れを見ると、早く掃除しなくてはと焦りを感じてしましたが、金曜日に家事代行が来てくれるから大丈夫だと少し気持ちに余裕を持てるようになりました。お風呂掃除担当の主人も負担が軽くなったと喜んでいました。</p>
            </div>
            <div className="user-voice">
              <img src="/images/lp/trial/user_kk.png" alt="" />
              <p className="profile">中央区在住・会社員・Kさん</p>
              <p className="comment">水回りを綺麗に維持する事が出来ています。 今まで気がつかなかった所も掃除してもらえて、気持ちが良いです。水回りのお掃除が常に心の負担でしたので、その負担が軽減されています。</p>
            </div>
          </div>

          <div className="cv-button">
            <button onClick={this.send.bind(this)}>お申し込みはこちら</button>
          </div>

          <div className="content">
            <p className="content-title">三菱地所が考える、<br />新しい家事代行サービスとは</p>
            <div className="scheme">
              <img src="/images/lp/trial/scheme.png" alt="" />
              <p>マンション内や近隣エリア内のご近所さんを巡回して提供するサービスの為、従来の家事代行サービスと比べ、短時間でのサービスを実現。エリア内に利用者が増えると利用しやすくなるため、ぜひマンション内のお友達を誘ってみてください。</p>
              <div className="points">
                <div className="point">
                  <img src="/images/lp/trial/point1.png" alt="[POINT 1]" />
                  <p className="point-title">エリア巡回型</p>
                  <p>スタッフがマンション内やご近所さんを巡回してサービスを行う家事代行の新スタイル！</p>
                </div>
                <div className="point">
                  <img src="/images/lp/trial/point2.png" alt="[POINT 2]" />
                  <p className="point-title">ショートステイ</p>
                  <p>エリア内のサービスご利用日をまとめることで、今までになかった短時間利用を実現！</p>
                </div>
                <div className="point">
                  <img src="/images/lp/trial/point3.png" alt="[POINT 3]" />
                  <p className="point-title">ピンポイント</p>
                  <p>短時間利用により、手のまわらない家事だけを、ピンポイントで利用OK！</p>
                </div>
                <br className="clear" />
              </div>
            </div>
          </div>

          <div className="cv-button">
            <button onClick={this.send.bind(this)}>お申し込みはこちら</button>
          </div>

          <div className="content">
            <p className="content-title">三菱地所の新しい家事代行は、<br />こんなライフシーンをかなえます。</p>
            <div className="life-styles">
              <div className="life-style">
                <img src="/images/lp/trial/life-style1.png" alt="[LIFE STYLE1]" />
                <p className="life-style-title">心が整う</p>
                <p>平日のどこか一日だけでも、家に帰って掃除しなくていい日があるだけで、会社帰りの電車も気持ちが軽くなる。</p>
              </div>
              <div className="life-style">
                <img src="/images/lp/trial/life-style2.png" alt="[LIFE STYLE2]" />
                <p className="life-style-title">家事をバトンタッチ</p>
                <p>仕事も家事も子育てもがんばりたい。でも「たまに」でいいから、家事をバトンタッチできると、自分の自由な時間が増える。</p>
              </div>
            </div>
          </div>

          <div className="content">
            <div className="recommends-wrapper">
              <div className="recommends">
                <p className="content-title">こんな想いの人にオススメ！！</p>
                <div className="recommend">
                  <img src="/images/lp/trial/recommend1.png" alt="" />
                  <p>子育てと仕事を両立！家事をアウトソースして、子供と過ごす時間を作りたい方</p>
                </div>
                <div className="recommend">
                  <img src="/images/lp/trial/recommend4.png" alt="" />
                  <p>テレワーク環境改善！散らかった部屋が気になって、仕事に集中できないなと思った事がある方</p>
                </div>
                <div className="recommend">
                  <img src="/images/lp/trial/recommend2.png" alt="" />
                  <p>家でゆっくり過ごしたい！家事が体力的に辛く、カラダを休ませたいと思った事がある方</p>
                </div>
              </div>
            </div>
          </div>

          <div className="cv-button">
            <button onClick={this.send.bind(this)}>お申し込みはこちら</button>
          </div>

          <div className="content">
            <div className="message">
              <div className="message-title">
                <img src="/images/lp/trial/message.png" alt="" />
              </div>
              <p>今の家事代行のイメージを変え、誰もが気軽に家事代行を利用できるように。様々な視点から家事代行を見つめ直していくプロジェクトです。</p>
            </div>
          </div>

          <div className="precautions">
            <div className="precaution">
              <p className="precaution-title">【キャンペーンのご利用について】</p>
              <p>●お客様からのお申込後、事務局よりメールにて候補日をご連絡させて頂きます。（迷惑メール対策やドメイン指定受信等を設定している方は、確認メールが受信されますよう、【@mec.co.jp】の登録をお願い致します）</p>
              <p>●お客様のご希望の曜日や時間帯等によっては、サービスのご提供を致しかねる場合がございます。予めご了承ください。</p>
              <p>●今後、新型コロナウィルス感染症の感染拡大の状況によっては、内容等変更させていただく場合がございます。</p>
            </div>
            <div className="precaution">
              <p className="precaution-title">【ご利用にあたってのお願い】</p>
              <p>●キャンペーンご利用後にアンケート及び15～20分程度のインタビュー（電話又はZoomによる）へのご協力を是非お願い致します。</p>
            </div>
            <div className="precaution">
              <p className="precaution-title">【キャンペーンご利用後の継続利用について】</p>
              <img src="/images/lp/trial/price-table.png" alt="" />
              <p>※料金は1回あたり・交通費込みの価格となります。</p>
            </div>
            <div className="precaution">
              <p>●本サービスは、マンション内をハウスキーパーが巡回することにより、短時間（30分）からのサービス提供を可能とするサービスでございます。サービスの提供にあたりましては、同じ曜日・同じ時間帯に一定数のお客様が集まる事が条件となります事をご了承ください。</p>
              <p>●本サービスは、現在、事業化検証中のサービスとなることをご了承ください。今後、諸般の事情により、サービス内容に変更等が生じる可能性がございます。</p>
              <p>●本サービスの価格は全て税込総額表示となっています。</p>
            </div>
          </div>

          <div className="cv-button">
            <button onClick={this.send.bind(this)}>お申し込みはこちら</button>
          </div>

          <div className="footer">
            <p className="footer-title">直接のお問い合わせはこちら</p>
            <p className="contact-department-title">三菱地所株式会社 住宅業務企画部</p>
            <p className="contact-department">（家事代行実証実験事務局）</p>
            <p className="contact-mail">thirty-min@mec.co.jp</p>
            <p className="contact-tel">03-3287-3384／03-3287-7706</p>
          </div>

        </div>
      </div>
    </div>
    );
  }
}